import type {ReactElement} from 'react';
import React from 'react';
import {useAppSelector} from '@/hooks';
import styles from './snackbar-message-growl.module.scss';
import {SnackbarMessageGrowlItem} from './snackbar-message-growl-item';

interface SnackbarMessageGrowlProps {
  className?: string;
  translateXValue?: number;
  zIndex?: number;
}

const DEFAULT_Z_INDEX = 20;

export function SnackbarMessageGrowl({zIndex = DEFAULT_Z_INDEX, className = '', ...props}: SnackbarMessageGrowlProps): ReactElement {
  const growls = useAppSelector((state) => {
    return state.messageGrowl.growls;
  });

  return (
    <div
      style={{
        transform: props.translateXValue !== undefined ? `translateX(calc(-50% + ${props.translateXValue}px))` : 'translateX(-50%)',
        zIndex: zIndex,
      }}
      className={`${styles.snackbarContainer} ${className}`}
    >
      {growls.map((growl) => {
        return <SnackbarMessageGrowlItem key={growl.key} growl={growl} />;
      })}
    </div>
  );
}
